import React from 'react';
import { Autocomplete, Checkbox, Chip, FormControlLabel, TextField } from '@mui/material';

const AUTOCOMPLETE_CLASSES = {
    paper: 'setup-autocomplete-paper',
    listbox: 'setup-autocomplete-listbox',
    option: 'setup-autocomplete-option',
};

const PERMISSION_FIELDS = [
    { key: 'canViewAllCompanyData', label: 'Kan se al virksomhedsdata' },
    { key: 'canViewPhysicalMachineData', label: 'Kan se data fra fysiske maskiner' },
    { key: 'canViewWasteReceiverSortingList', label: 'Kan se sorteringsliste (kun læsning)' },
];

const AttachmentPicker = ({ label, helperText, options, value, onChange, getLabel, loading, disabled }) => (
    <Autocomplete
        multiple
        filterSelectedOptions
        loading={loading}
        disabled={disabled || loading}
        classes={AUTOCOMPLETE_CLASSES}
        options={options}
        value={value}
        onChange={(_, next) => onChange(next)}
        getOptionLabel={getLabel}
        renderTags={(tags, getTagProps) =>
            tags.map((option, index) => {
                const { key, ...tagProps } = getTagProps({ index });
                return <Chip key={key} {...tagProps} size="small" label={getLabel(option)} className="setup-chip" />;
            })
        }
        renderInput={(params) => <TextField {...params} label={label} helperText={helperText} size="small" />}
    />
);

// The access a user has: waste receivers, companies, and the permission flags that come with
// each company. Used by the user editor and by the create-users dialog, whose batch shares one.
const UserAccessFields = ({
    wasteReceiverIds,
    companyIds,
    wasteReceiverOptions,
    companyOptionIds,
    getPermission,
    onWasteReceiversChange,
    onCompaniesChange,
    onPermissionChange,
    getWasteReceiverDisplayLabel,
    getCompanyDisplayLabel,
    loadingReceivers,
    loadingCompanies,
    disabled,
    wasteReceiverHelperText = 'Hvilke affaldsmodtagere brugeren har adgang til.',
}) => (
    <>
        <AttachmentPicker
            label="Affaldsmodtagere"
            helperText={wasteReceiverHelperText}
            options={wasteReceiverOptions}
            value={wasteReceiverIds}
            onChange={onWasteReceiversChange}
            getLabel={getWasteReceiverDisplayLabel}
            loading={loadingReceivers}
            disabled={disabled}
        />
        <AttachmentPicker
            label="Virksomheder"
            helperText="Rettigheder følger med hver virksomhed nedenfor."
            options={companyOptionIds}
            value={companyIds}
            onChange={onCompaniesChange}
            getLabel={getCompanyDisplayLabel}
            loading={loadingCompanies}
            disabled={disabled}
        />

        {companyIds.length > 0 && (
            <div className="setup-form-section">
                <div className="setup-form-section-header">
                    <h3>Rettigheder pr. virksomhed</h3>
                </div>

                <div className="company-permission-list">
                    {companyIds.map((companyId) => {
                        const permission = getPermission(companyId);

                        return (
                            <div className="company-permission-row" key={`user-permission-${companyId}`}>
                                <TextField
                                    value={getCompanyDisplayLabel(companyId)}
                                    size="small"
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                />

                                <div className="company-permission-controls">
                                    {PERMISSION_FIELDS.map(({ key, label }) => (
                                        <FormControlLabel
                                            key={key}
                                            control={
                                                <Checkbox
                                                    checked={permission[key]}
                                                    disabled={disabled}
                                                    onChange={(event) =>
                                                        onPermissionChange(companyId, key, event.target.checked)
                                                    }
                                                />
                                            }
                                            label={label}
                                        />
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        )}
    </>
);

export { PERMISSION_FIELDS };
export default UserAccessFields;
